'use strict';

var ROMServicesFilterFactory = function ROMServicesFilterFactory(DataFilter) {
  function ROMServicesFilter() {
    DataFilter.call(this, ['rom-analysis-loco-mode', 'rom-analysis-demand-pax-mode', 'rom-analysis-flattened-services-mode'], 'filter-component', 2);
  }
  ROMServicesFilter.prototype = Object.create(DataFilter.prototype);
  ROMServicesFilter.prototype.filter = function (data, range) {
    range = range[0];
    var filtered = DataFilter.prototype.filter(data, range.service, 'service');
    return filtered;
  };
  return ROMServicesFilter;
};
ROMServicesFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ROMServicesFilterFactory;